// extracted by mini-css-extract-plugin
module.exports = {"post":"work-module--post--3CzzM"};